import React from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Divider from "@material-ui/core/Divider";
import { colors } from "@material-ui/core";
import DiscountsPermisson from "../DiscountsPermisson";
import { permOrder } from "../checksPermmision";
import CheckboxItems, { useStylesAccs } from "../CheckBoxComponents";

export default function OrdersPermission(props) {
    const { onChange, object } = props;
    const classes = useStylesAccs();
    return (
        <div className={classes.root}>
            <Accordion expanded={true}>
                <AccordionDetails >
                    <Grid item container spacing={1}>
                        {permOrder
                            ?.filter((d) => d.visible)
                            ?.map((item) => {
                                return (
                                    <Grid xs={6}>
                                        <CheckboxItems
                                            value={object[item.name] ?? null}
                                            name={item.name}
                                            label={item.label}
                                            onChange={onChange}
                                        />
                                    </Grid>
                                );
                            })}
                    </Grid>
                </AccordionDetails>
                <AccordionDetails>
                    {" "}
                    <Typography> {"إعدادات الخصومات "}
                    </Typography>{" "}
                </AccordionDetails>

                <AccordionDetails style={{ backgroundColor: colors.grey[50] }}>
                    {object?.allow_discount ? <DiscountsPermisson {...props} /> :
                        <Typography variant="h5" style={{ textAlign: "center" }}>
                            {"\n تاكد من تفعيل السماح بالخصم حتى يتم تفعيل الخيارات"}
                        </Typography>}
                </AccordionDetails>
                <Divider className={classes.divider} />
            </Accordion>
            <Swipeable />
        </div>
    );
}
